/**
 * T5(docs/50)— 說明 / 知識庫(M-18,Phase 1)型別
 * -----------------------------------------------------------------------------
 * 對齊後端 `GET /help/categories` / `GET /help/articles` / `GET /help/articles/{slug}`。
 * Phase 1:範例文章靜態存後端(`app/help` seed),read-only;**非** group-scoped
 * (登入即可,不帶 `X-Current-Group`)。Phase 2 換 Firestore + admin 管理(契約不變)。
 */

/** 5 類固定序;對應 FE 既有 icon / 色彩映射(by key)。 */
export type HelpCategoryKey = 'started' | 'features' | 'faq' | 'video' | 'releases';

/** 計數語彙(決定「N 篇 / N 問答 / N 影片 / N 版本」文案)。 */
export type HelpCountKind = 'articles' | 'qa' | 'video' | 'versions';

// ─── DTO（snake_case）────────────────────────────────────────────────────────

export interface HelpCategoryDto {
  key: HelpCategoryKey;
  count: number;
  count_kind: HelpCountKind;
}

export interface HelpArticleListItemDto {
  id: string;
  slug: string;
  title: string;
  category: HelpCategoryKey;
  excerpt: string;
  read_minutes: number;
  is_popular: boolean;
  updated_at: string;
}

export interface HelpArticleDetailDto extends HelpArticleListItemDto {
  body_md: string;
  created_at: string;
}

// ─── camelCase ────────────────────────────────────────────────────────────────

export interface HelpCategory {
  key: HelpCategoryKey;
  count: number;
  countKind: HelpCountKind;
}

export interface HelpArticleListItem {
  id: string;
  slug: string;
  title: string;
  category: HelpCategoryKey;
  excerpt: string;
  readMinutes: number;
  isPopular: boolean;
  updatedAt: string;
}

export interface HelpArticleDetail extends HelpArticleListItem {
  /** Markdown 原文;FE 端目前以純文字(whitespace-pre-wrap)安全渲染,不解析 HTML。 */
  bodyMd: string;
  createdAt: string;
}

// ─── DTO → camelCase mapping ─────────────────────────────────────────────────

export function mapHelpCategoryDto(dto: HelpCategoryDto): HelpCategory {
  return { key: dto.key, count: dto.count, countKind: dto.count_kind };
}

export function mapHelpArticleListItemDto(dto: HelpArticleListItemDto): HelpArticleListItem {
  return {
    id: dto.id,
    slug: dto.slug,
    title: dto.title,
    category: dto.category,
    excerpt: dto.excerpt,
    readMinutes: dto.read_minutes,
    isPopular: dto.is_popular,
    updatedAt: dto.updated_at,
  };
}

export function mapHelpArticleDetailDto(dto: HelpArticleDetailDto): HelpArticleDetail {
  return {
    ...mapHelpArticleListItemDto(dto),
    bodyMd: dto.body_md,
    createdAt: dto.created_at,
  };
}
